export function isFaqMainContentEmpty(props) {
    return !props.sections || props.sections.length === 0;
}
export const getMarginTopForFAQ = (isDesktop, isMarginNeeded) => {
    if (isMarginNeeded) {
        return isDesktop ? '48px' : '32px';
    }
    return undefined;
};
